import type { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { Paper } from 'shared/ui/paper'

import type { ObjectBooking, ObjectBookingStatus } from '../../model/types'

import s from './styles.module.scss'

interface Props {
  booking: ObjectBooking
  variant?: 'compact' | 'full'
}

const statusClassName: Record<ObjectBookingStatus, string> = {
  payment_pending_confirmation: s.paymentPendingConfirmation,
  confirmed: s.confirmed,
  refund_pending: s.refundPending,
  cancelled: s.cancelled,
  refunded: s.refunded,
  refund_rejected: s.refundRejected,
}

export const BookingCard: FC<Props> = ({ booking, variant = 'compact' }) => {
  const { t } = useTranslation()

  return (
    <Paper
      padding={[12]}
      radius="16px"
      className={clsx(s.card, {
        [s.compact]: variant === 'compact',
        [s.full]: variant === 'full',
      })}
    >
      <div className={s.content}>
        <div className={s.badges}>
          <span
            className={clsx(
              'semi-bold-12',
              s.badge,
              statusClassName[booking.status],
            )}
          >
            {booking.statusLabel}
          </span>

          <span className={clsx('semi-bold-12', s.dateBadge)}>
            {t('kyrgyzstan_block.my_objects.bookings.date', {
              startDate: booking.startDate,
              endDate: booking.endDate,
            })}
          </span>
        </div>

        <div className={s.info}>
          <span className={clsx('semi-bold-14', s.title)}>{booking.title}</span>
          <span className={clsx('regular-12', s.details)}>
            {t('kyrgyzstan_block.my_objects.bookings.details', {
              nightsCount: booking.nightsCount,
              guestsCount: booking.guestsCount,
            })}
          </span>
          <span className={clsx('regular-12', s.address)}>
            {booking.address}
          </span>
        </div>
      </div>
    </Paper>
  )
}
